module.exports = __webpack_public_path__ + "static/tell-logo-white-7e70465561f16070fc4c8328bd05599f.png";